<template>
    <v-container>
        <v-row>
            <v-col>

                <div class="headline">Ressurser</div>
                <br>

                <v-btn @click="openNewResource" color="success">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Ny ressurs
                </v-btn>

                <v-row>
                    <v-col>
                        <v-data-table :headers="headers" :items="resources" :loading="resourcesLoading" hide-default-footer :items-per-page="-1" :mobile-breakpoint="0">
                            <template v-slot:item={item}>
                                <tr @click="openEditResource(item)" style="cursor: pointer">
                                    <td>
                                        <v-chip pill>
                                            <v-avatar :class="item.color" left></v-avatar>
                                            {{item.name}}
                                        </v-chip>
                                    </td>
                                    <td>{{item.available}}</td>
                                    <td>{{colors[colors.findIndex(c => c.name == item.color)].value}}</td>
                                    <td>
                                        <div class="d-flex">
                                            <v-btn icon @click.stop="openEditResource(item)">
                                                <v-icon color="info">mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon @click.stop="confirmDeleteResource(item)">
                                                <v-icon color="info">mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog v-model="newResource.show" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Ny ressurs
                </v-card-title>
                <v-card-text>
                    <v-form v-model="newResource.valid" ref="newResourceForm">
                        <v-text-field v-model="newResource.name" label="Navn" required type="text" :rules="[v => !!v || 'Navn påkrevd']"></v-text-field>
                        <v-text-field v-model="newResource.available" label="Tilgjengelighet" required type="number" :rules="[v => !!v || 'Tilgjengelighet påkrevd', v => (Number.parseInt(v, 10) != NaN && Number.isInteger(Number(v)) && v > 0) || 'Tilgjengelighet må være positivt heltall']"></v-text-field>
                        <v-select v-model="newResource.color" :items="colors" item-text="value" return-object></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="newResource.show = false">Avbryt</v-btn>
                    <v-btn @click="submitNewResource" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editResource.show" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Rediger ressurs: {{editResource.resource.name}}
                </v-card-title>
                <v-card-text>
                    <v-form v-model="editResource.valid" ref="editResourceForm">
                        <v-text-field v-model="editResource.resource.name" label="Navn" required type="text" :rules="[v => !!v || 'Navn påkrevd']"></v-text-field>
                        <v-text-field v-model="editResource.resource.available" label="Tilgjengelighet" required type="number" :rules="[v => !!v || 'Tilgjengelighet påkrevd', v => (Number.parseInt(v, 10) != NaN && Number.isInteger(Number(v)) && v > 0) || 'Tilgjengelighet må være positivt heltall']"></v-text-field>
                        <v-select v-model="editResource.resource.color" :items="colors" item-text="value" return-object></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="editResource.show = false">Avbryt</v-btn>
                    <v-btn @click="submitEditResource(editResource.resource)" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteResourceObject.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Slett ressurs: {{deleteResourceObject.name}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteResourceObject.show = false">Avbryt</v-btn>
                    <v-btn @click="deleteResource(deleteResourceObject)" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            resources: [],
            resourcesLoading: false,
            headers: [
                { text: "Navn", value: "name", sortable: true },
                {
                    text: "Tilgjengelighet",
                    value: "available",
                    sortable: false
                },
                { text: "Farge", value: "color", sortable: false },
                { text: "Handlinger", sortable: false }
            ],
            colors: [
                { name: "red", value: "rød" },
                { name: "pink", value: "rosa" },
                { name: "purple", value: "lilla" },
                { name: "deep-purple", value: "mørk lilla" },
                { name: "indigo", value: "indigo" },
                { name: "blue", value: "blå" },
                { name: "light-blue", value: "lyse blå" },
                { name: "cyan", value: "cyan" },
                { name: "teal", value: "blågrønn" },
                { name: "green", value: "grønn" },
                { name: "light-green", value: "lyse grønn" },
                { name: "lime", value: "lime" },
                { name: "yellow", value: "gul" },
                { name: "amber", value: "rav" },
                { name: "orange", value: "oransje" },
                { name: "deep-orange", value: "mørk oransje" },
                { name: "brown", value: "brun" },
                { name: "blue-grey", value: "blå grå" },
                { name: "grey", value: "grå" }
            ],
            newResource: {
                show: false,
                valid: false,
                name: "",
                available: 1,
                color: null
            },
            editResource: {
                show: false,
                resource: {},
                valid: false,
                name: "",
                available: 1,
                color: null
            },
            deleteResourceObject: {
                show: false,
                name: ""
            }
        };
    },
    methods: {
        openEditResource: function(resource) {
            // this.editResource = resource;
            Object.assign(this.editResource.resource, resource);

            this.editResource.resource.color = this.colors[this.colors.findIndex(c => c.name == resource.color)];

            this.editResource.show = true;
        },
        submitEditResource: function(resource) {
            resource.color = resource.color.name;
            delete resource.show; // TODO: risky! the object may actually have this property
            delete resource.valid; // TODO: risky! the object may actually have this property

            this.axios.post(`/resource/${resource.id}`, resource).then(response => {
                if (response.data.success) {
                    let index = this.resources.findIndex(r => r.id == resource.id);
                    if (index >= 0) {
                        this.resources.splice(index, 1);
                        this.resources.splice(index, 0, resource);
                        this.editResource.show = false;
                    }
                }
            });
        },
        openNewResource: function() {
            this.newResource.name = "";
            this.newResource.available = 1;
            this.newResource.color = this.colors[0];

            this.newResource.show = true;
        },
        submitNewResource: function() {
            if (this.$refs.newResourceForm.validate()) {
                let resource = {
                    name: this.newResource.name,
                    available: this.newResource.available,
                    color: this.newResource.color.name
                };

                this.axios.put("/resource", resource).then(response => {
                    if (response.data.success) {
                        this.resources.push(response.data.data);
                        this.newResource.show = false;
                    } else {
                        // TODO: toastr
                    }
                });
            }
        },
        confirmDeleteResource: function(resource) {
            Object.assign(this.deleteResourceObject, resource);

            this.deleteResourceObject.show = true;
        },
        deleteResource: function(resource) {
            let index = this.resources.findIndex(r => r.id == resource.id);
            if (index >= 0) {
                this.axios.delete(`/resource/${resource.id}`).then(response => {
                    if (response.data.success) {
                        this.resources.splice(index, 1);
                        this.deleteResourceObject.show = false;
                    }
                });
            }
        }
    },
    mounted() {
        this.resourcesLoading = true;
        this.axios
            .get(`/resource`)
            .then(response => {
                if (response.data.success) {
                    this.resources = response.data.data;
                }
            })
            .finally(() => {
                this.resourcesLoading = false;
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
